// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".name_product[data-v-4a417478]{color:#000!important;font-weight:700!important}.name_product[data-v-4a417478]:after{content:\"*\";position:absolute;top:0;left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
